// Prevent Multiple Clicks on Contact Form 7 Submissions
jQuery(document).on('click', '.wpcf7-form.submitting .wpcf7-submit', function(e) {
    e.preventDefault();
    return false;
});
